import { memo, useEffect, useState } from "react";
import styles from "./dealerships.module.scss";
import { images } from "../../../constants/images";
import { DealershipsPageProps } from "../../../interfaces/pages";
import ProfileCard from "../../../components/ProfileCard";
import { IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, CircularProgress } from "@mui/material";
import NoDataList from "../../../components/NoDataList/NoDataList";
import { useToast } from "../../../helpers/hooks";
import { capitalize } from '../../../helpers/app';
import ButtonShared from "../../../components/Button/Button";
import AddIcon from '@mui/icons-material/Add';
import CreateIcon from '@mui/icons-material/Create';
import DeleteIcon from '@mui/icons-material/Delete';
import Pagination from "../../../components/Pagination/Pagination";
import Sidebar from "../../../containers/Profile/Dealerships/Sidebar/SidebarContainer";
import Delete from "../../../containers/Profile/Dealerships/Delete/DeleteContainer";

const Dealerships = ({
    getDealerships,
    dealerships,
    cleanGetDealerships
}: DealershipsPageProps) => {
    const toast = useToast();
    const [page, setPage] = useState<number>(1);
    const [dealershipsAux, setDealershipsAux] = useState<any>([]);
    const [totalDealerships, setTotalDealerships] = useState<number>(1);
    const [loading, setLoading] = useState<any>([]);
    const [sidebarState, setSidebarState] = useState<any>({open: false, type: "add"});
    const [dealershipSelected, setDealershipSelected] = useState<any>([]);
    const [openModalDelete, setOpenModalDelete] = useState<boolean>(false);

    const onAddDealership = () => {
        setDealershipSelected({});
        setSidebarState({open: true, type: "add"});
    }
    
    const onEditDealership = (item: any, event: any) => {
        setDealershipSelected(item);
        setSidebarState({open: true, type: "edit"});
    }

    const onDeleteDealership = (item: any, event: any) => {
        setDealershipSelected(item);
        setOpenModalDelete(true)
    }

    useEffect(() => {
        if(dealerships?.list?.fetching === "loading" && dealershipsAux?.length > 0){
            setLoading(true);
        }
        if(dealerships?.list?.fetching === "failure"){
            setLoading(false);
            toast("Ha ocurrido un error al cargar los usuarios");
            cleanGetDealerships();
        }
        if(dealerships?.list?.fetching === "success"){
            setDealershipsAux(dealerships?.list?.data);
            cleanGetDealerships();
            setLoading(false);
        }
        if (dealerships?.list?.total) {
            setTotalDealerships(Math.ceil(dealerships?.list?.total / 10));
        }
    }, [dealerships?.list?.fetching]);

    useEffect(() => {
        if(dealerships?.add?.fetching === "success" || dealerships?.edit?.fetching === "success"){
            getDealerships(page);
        }
    }, [dealerships?.add?.fetching, dealerships?.edit?.fetching]);

    useEffect(() => {
        getDealerships(page);
    }, [page]);

    return (
        <>
            <Sidebar 
                state={sidebarState} 
                setState={setSidebarState} 
                dealershipSelected={dealershipSelected} 
            />
            <Delete
                open={openModalDelete} 
                setOpen={setOpenModalDelete}
                dealershipSelected={dealershipSelected} 
                loading={dealerships?.delete?.fetching === "loading"}
            />
            <ProfileCard>
                <div className={styles.container}>
                    {
                        (dealerships?.list?.fetching === "loading" && dealershipsAux?.length === 0) 
                        ?   <div className={styles.loaderBranches} id="loaderBranches">
                    <CircularProgress 
                        size={styles.loader}
                        classes={{
                            colorPrimary: styles.loader
                        }}
                    />
                    <p>Cargando concesionarios</p>
                </div>
                        :
                            <div className={styles.content}>
                                <div className={styles.header}>
                                    <ButtonShared
                                        onPress={onAddDealership}
                                        title="Añadir"
                                        icon={<AddIcon className={styles.iconButton} />}
                                        primary
                                    />
                                    {/* <TextFieldShared
                                        variant="search"
                                        label="Buscar concesionarias"
                                        name="search"
                                        value={search}
                                        onChange={(value: any) => setSearch(value)}
                                        className={styles.inputSearch}
                                        onEnter={onEnterSearch}
                                    /> */}
                                </div>
                                <div id="dealershipList" className={styles.list}>
                                    {
                                        dealershipsAux && dealershipsAux.length === 0
                                        ?
                                            <div className={styles.noData}>
                                               <NoDataList
                            title="Aún no tienes concesionarios"
                            text="Añade un concesionario para ver los detalles en esta sección"
                            image={images.noBranches}
                            className={styles.message}
                        />
                                            </div>
                                        :
                                            <TableContainer className={`${styles.table} ${loading && styles.loading}`}>
                                                <Table>
                                                    <TableHead>
                                                        <TableRow className={styles.head}>
                                                            <TableCell className={styles.cell}>Nombre</TableCell>
                                                            <TableCell className={styles.cell}>Dirección</TableCell>
                                                            <TableCell className={styles.cell}>Contacto</TableCell>
                                                            <TableCell className={styles.cell}>Email</TableCell>
                                                            <TableCell className={styles.cell}>Telefono</TableCell>
                                                            <TableCell className={styles.cell}></TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {
                                                            dealershipsAux && dealershipsAux.length > 0 && dealershipsAux?.map((item: any, index: number) => {
                                                                return <TableRow key={index} className={styles.row}>
                                                                    <TableCell className={`${styles.cell} ${styles.bold}`}>
                                                                        <p className={styles.text}>{capitalize(item?.name)}</p>
                                                                    </TableCell>
                                                                    <TableCell className={`${styles.cell} ${styles.address}`}>
                                                                        <p className={styles.text}>{item?.address}</p>
                                                                    </TableCell>
                                                                    <TableCell className={styles.cell}>
                                                                        <p className={styles.text}>{`${capitalize(item?.contact?.name)} ${capitalize(item?.contact?.last_name)}`}</p>
                                                                    </TableCell>
                                                                    <TableCell className={`${styles.cell} ${styles.bold}`}>
                                                                        <p className={styles.text}>{item?.contact?.email}</p>
                                                                    </TableCell>
                                                                    <TableCell className={styles.cell}>
                                                                        <p className={styles.text}>{`${item?.contact?.phone?.code} ${item?.contact?.phone?.number}`}</p>
                                                                    </TableCell>
                                                                    <TableCell className={styles.cell}>
                                                                        <div className={styles.action}>
                                                                            <IconButton title="Editar" onClick={(event: any) => onEditDealership(item, event)} disabled={loading}>
                                                                                <CreateIcon className={styles.icon} />
                                                                            </IconButton>
                                                                            {/* <IconButton title="Eliminar" onClick={(event: any) => onDeleteDealership(item, event)} disabled={loading}>
                                                                                <DeleteIcon className={styles.icon} />
                                                                            </IconButton> */}
                                                                        </div>
                                                                    </TableCell>
                                                                </TableRow>
                                                            })
                                                        }
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                    }
                                </div>
                                <Pagination 
                                    page={page}
                                    setPage={setPage}
                                    className={styles.pagination}
                                    total={totalDealerships}
                                />
                            </div>
                    }
                </div>
            </ProfileCard>
        </>
    )
}

export default memo(Dealerships);